import React, { createContext, useContext, useMemo, useState } from 'react';

export const SimpleSearchContext = createContext();

export const SimpleSearchProvider = ({ children }) => {
  const [isOpened, setIsOpened] = useState(false);

  const state = useMemo(() => ({ isOpened, setIsOpened }), [isOpened]);

  return <SimpleSearchContext.Provider value={state}>{children}</SimpleSearchContext.Provider>;
};

export const useSimpleSearchState = () => useContext(SimpleSearchContext);
